import React from 'react';
import SubjectCard from '../SubjectCard/SubjectCard';
import './SubjectsGrid.css';

const SubjectsGrid = () => {
  return (
    <div>
      <div className="subjectCard">
        <SubjectCard />
      </div>
      {/* <div className="MyCourses__statistic">
        <h2>Статистика</h2>
        <span>В разработке</span>
      </div> */}
    </div>
  );
};

export default SubjectsGrid;
